import { render, staticRenderFns } from "./TestPicList.vue?vue&type=template&id=732c3f54"
import script from "./TestPicList.vue?vue&type=script&lang=js"
export * from "./TestPicList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('732c3f54')) {
      api.createRecord('732c3f54', component.options)
    } else {
      api.reload('732c3f54', component.options)
    }
    module.hot.accept("./TestPicList.vue?vue&type=template&id=732c3f54", function () {
      api.rerender('732c3f54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/test/pic/TestPicList.vue"
export default component.exports